import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptor } from './interceptors/http.interceptor';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { CallbackComponent } from '../modules/auth/callback/callback.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserReducer } from './state/_reducers/user.reducers';
import { ApplicationReducer } from './state/_reducers/application.reducers';
import { TableReducer } from './state/_reducers/table.reducers';
import { PagesReducers } from './state/_reducers/settings/pages.reducers';
import { DashboardsReducers } from './state/_reducers/settings/dashboards.reducers';
import { UserEffect } from './state/_effects/user.effects';
import { ApplicationEffect } from './state/_effects/application.effects';
import { TableEffect } from './state/_effects/table.effects';
import { PagesEffects } from './state/_effects/settings/pages.effects';
import { DashboardsEffects } from './state/_effects/settings/dashboards.effects';
import { AuthReducer } from './state/_reducers/auth.reducers';
import { AuthEffect } from './state/_effects/auth.effects';
import { EncryptionInterceptor } from './interceptors/encryption.interceptor';

@NgModule({
  declarations: [CallbackComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature('user', UserReducer),
    StoreModule.forFeature('application', ApplicationReducer),
    StoreModule.forFeature('table', TableReducer),
    StoreModule.forFeature('pages', PagesReducers),
    StoreModule.forFeature('dashboards', DashboardsReducers),
    StoreModule.forFeature('auth', AuthReducer),
    EffectsModule.forFeature([
      UserEffect,
      ApplicationEffect,
      TableEffect,
      PagesEffects,
      DashboardsEffects,
      AuthEffect,
    ]),
  ],
  exports: [CallbackComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } }
  ],
})
export class CoreModule {}
